import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { Form, Loading } from 'components';

class RolesForm extends Component {
  state = {
    data: this.props.data,
  };

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleToggleScore = () => {
    const { data } = this.state;

    this.setState({ data: { ...data, score: !data.score } });
  };

  handleChangeInput = e => {
    const { value, name } = e.target;
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  render() {
    const { data } = this.state;
    const { saving, onSubmit } = this.props;

    return (
      <Form className="page-form">
        <h3 className="form-title">Permissões</h3>

        <Form.Field>
          <Form.Label>Nome</Form.Label>
          <Form.Input name="title" placeholder="Nome" value={data.title} onChange={this.handleChangeInput} />
        </Form.Field>

        <Form.Field>
          <Form.Label>Alias</Form.Label>
          <Form.Input name="alias" placeholder="Alias" value={data.alias} onChange={this.handleChangeInput} />
        </Form.Field>

        <Form.Field>
          <Form.Label>Descrição</Form.Label>
          <Form.Input
            name="description"
            placeholder="Descrição"
            value={data.description}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <div className="buttons">
          <Link to="/configs/roles" className="button-cancel">
            Cancelar
          </Link>

          <Form.Button className="button-save" onClick={onSubmit} disabled={saving}>
            {saving ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
          </Form.Button>
        </div>
      </Form>
    );
  }
}

export default RolesForm;
